<script>
import { conciliacaoClient, getValorPercentMessages, getItemPercentMessages } from '../../../libs'
import { pagamentoStatusTradimus } from '../../../libs/pagamento-status-tradimus'
import { pagamentoStatusLabels } from '@tradimus/api-conciliacao-client'
import PercentBar from '@/components/common/PercentBar.vue'
import PercentBarGroup from '@/components/common/PercentBarGroup'
import IntegracaoIcon from '@/components/recebiveis/lista_pagamentos/IntegracaoIcon'
import PagamentoLotesGroupedTable from './PagamentoLotesGroupedTable.vue'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import { mapActions } from 'vuex'
import format from 'date-fns/format'
import ptBR from 'date-fns/locale/pt-BR'

export default {
  components: {
    PercentBar,
    PercentBarGroup,
    IntegracaoIcon,
    PagamentoLotesGroupedTable
  },
  data () {
    return {
      pagamentoStatusLabels,
      pagamentoStatusTradimus,
      lotesList: [],
      lotesHeaders: [
        {
          text: 'Nº nota fiscal',
          value: 'numeroNotaFiscal',
          align: 'right',
          class: 'py-0'
        },
        {
          text: 'Nº lote',
          value: 'numeroLote',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Protocolo',
          value: 'numeroProtocolo',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor apresentado',
          value: 'valorInformado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor conciliado',
          value: 'valorConciliado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor liberado',
          value: 'valorLiberado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor glosado',
          value: 'valorGlosado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        }
      ],
      pageLotes: 0,
      totalLotesPages: 0,
      totalLotes: 0,
      statusIcons: {
        identificado: 'fas fa-search',
        valoresDivergentes: 'fas fa-not-equal',
        conciliacaoAutomaticaTradimus: 'fa-solid fa-robot',
        conciliacaoManualTradimus: 'fa-solid fa-user',
        conciliacaoManualCliente: 'fa-solid fa-user',
        conciliacaoAutomaticaCliente: 'fa-solid fa-robot',
        emProcessamento: 'fa-solid fa-clock',
        naoConciliado: 'fas fa-times-circle',
        conciliado: 'fa-sharp fa-solid fa-circle-check',
        publicacaoPendente: 'fas fa-upload',
        emPublicacao: 'fa-arrow-alt-circle-up',
        publicado: 'fa-user-check',
        concluido: 'fa-check-circle',
        gerandoArquivos: 'fa-folder',
        conclusaoPendente: 'fa-solid fa-flag'
      },
      historicoDialogOpen: false,
      historicoOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: []
      },
      historicoHeaders: [
        { value: 'dataEvento', text: 'Data do evento' },
        { value: 'authorName', text: 'Autor' },
        { value: 'descricao', text: 'Evento' }
      ],
      progressBarValores:{
        label: 'Valor',
        total: this.pagamento.percentualConciliadoValor,
        automatica: this.pagamento.percentualConciliadoValorAutomatico,
        manual: this.pagamento.percentualConciliadoValorManual,
        textAutomatica: 'Automatico',
        textManual: 'Manual',
        textRestante: 'Restante'
      },
      progressBarItens:{
        label: 'Itens',
        total: this.pagamento.percentualConciliadoQuantidade,
        automatica: this.pagamento.percentualConciliadoQuantidadeAutomatico,
        manual: this.pagamento.percentualConciliadoQuantidadeManual,
        textAutomatica: 'Automatico',
        textManual: 'Manual',
        textRestante: 'Restante'
      },
      statusesCount: {},
      groupedPagamentoLotes: [],
      groupedByNotaFiscal: false
    }
  },
  props: {
    pagamento: Object,
    isUsuarioTradimus: Boolean
  },
  methods: {
    ...mapActions({
      getDocument: 'documents/getDocument',
    }),
    async pagamentoClick () {
      const response = await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({ pagamentoId: this.pagamento.id, pageSize: 5 })
      this.lotesList = response.data
      this.pageLotes = 1
      this.totalLotes = response.totalSize
      this.totalLotesPages = Math.ceil(response.totalSize / response.pageSize)

      const result = await conciliacaoClient.pagamentoLote.getPagamentoLotesStatusesCount({ pagamentoId: this.pagamento.id })
      this.statusesCount = result.data.reduce((statuses, data) => {
        statuses[data.status] = data.count

        return statuses
      }, {})

      this.groupedPagamentoLotes = (await conciliacaoClient.pagamentoLote.getPagamentoLotesGroupedByNotaFiscal({ pagamentoId: this.pagamento.id })).data
    },
    async getLotesPagamento (currentPage) {
      const response = await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({ pagamentoId: this.pagamento.id, pageNumber: currentPage - 1, pageSize: 5 })
      this.lotesList = response.data
    },
    async handleQuitarClick () {
      try {
        const data = {
          data: [
            {
              pagamentoId: this.pagamento.id,
              quitado: this.pagamento.dataQuitacao == null
            }
          ]
        }
        await conciliacaoClient.pagamento.updatePagamentoQuitacao(data)
        this.$emit('refreshPage')
      } catch (error) {
        window.alert('Erro ao quitar pagamento')
      }
    },
    handleHistoricoOpen () {
      this.historicoDialogOpen = true
    },
    handleHistoricoClose () {
      this.historicoDialogOpen = false
    },
    handleConciliarClick () {
      this.$router.push({ name: 'pagamento', params: { pagamentoId: this.pagamento.id } })
    },
    handleIntegrarClick() {
      let paramModal = {
          type: "info",
          title: "Confirma integração do pagamento?",
          message: "Confirme a integração do pagamento selecionado.",
          callback: () => {
            this.integrarPagamento();
          },
          btConfirm: { name: "Confirmar", show: true, color: "primary" },
          btCancel: { name: "Cancelar", show: true, color: "primary"},
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    integrarPagamento() {
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "concluirintegracaosdi",
            Payload: { grupo_economico, pagamento_id: this.pagamento.codigoFrontend, prestador_id: this.pagamento.prestadorId },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
          },
          btConfirm: { name: "OK", show: true, color: "primary" },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    handleResumoClick () {
      this.$router.push({ name: 'pagamentoResumo', params: { pagamentoId: this.pagamento.id } })
    },
    handleDownloadResultado () {
      if (this.pagamento.docIdPlanilhaResultado) {
        this.getDocument({doc_id: this.pagamento.docIdPlanilhaResultado})
      } else {
        this.openModal('Documento indisponível')
      }
    },
    handleDownloadDAC () {
      if (this.pagamento.docIdDac) {
        this.getDocument({doc_id: this.pagamento.docIdDac})
      } else {
        this.openModal('Documento indisponível')
      }
    },
    openModal(message) {
      const paramModal = {
        type: 'warning',
        message: message,
        btCancel: {
          name: 'Cancelar',
          show: false
        },
        btConfirm: {
          name: 'Ok',
          show: true,
          color: 'primary'
        }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
    },
    handleComentariosCLick () {
      this.$router.push({ name: 'pagamento', params: { pagamentoId: this.pagamento.id }, hash: '#comentarios' })
    }
  },
  filters: {
    formatPercent(value) {
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 2 })
      return formatter.format(value)
    },
    formatDate (date) {
      if (date?.toString().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
        const match = date.toString().match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)

        return `${match[3]}/${match[2]}/${match[1]}`
      }

      return date ? format(new Date(date), 'Pp', { locale: ptBR }) : '-'
    },
    pluralize (count) {
      if (count === 0) {
        return 'Nenhum comentário disponível'
      } else if (count === 1) {
        return 'Pagamento possui 1 comentário'
      } else {
        return `Pagamento possui ${count} comentários`
      }
    }
  },
  asyncComputed: {
    pagamentoEventosPage: {
      get () {
        const params = {
          pageNumber: this.historicoOptions.page - 1,
          pageSize: this.historicoOptions.itemsPerPage,
          pagamentoId: this.pagamento.id
        }
        return conciliacaoClient.pagamentoEvento.getPagamentoEventosPage(params)
      }
    },
    getPagamentoArquivosPage: {
      get () {
        const params = {
          pagamentoId: this.pagamentoId
        }
        return conciliacaoClient.pagamentoArquivo.getPagamentoArquivosPage(params)
      }
    }
  },
  computed: {
    itensConciliacaoTexts () {
      return getItemPercentMessages(
        this.pagamento.quantidadeItem,
        this.pagamento.quantidadeItemConciliadoAutomatico,
        this.pagamento.quantidadeItemConciliadoManual
      )
    },
    valorTotal () {
      return this.pagamento.valorPago + this.pagamento.valorGlosado
    },
    valorConciliadoAutomaticoTotal () {
      return this.pagamento.valorPagoConciliadoAutomatico + this.pagamento.valorGlosadoConciliadoAutomatico
    },
    valorConciliadoManualTotal () {
      return this.pagamento.valorPagoConciliadoManual + this.pagamento.valorGlosadoConciliadoManual
    },
    isQuitado () {
      return this.pagamento.dataQuitacao !== null
    },
    sla () {
      const dataIdentificacao = new Date(this.pagamento.dataIdentificacao)
      const diasDiferenca = differenceInCalendarDays(new Date(), dataIdentificacao)
      if (diasDiferenca <= 3) return 3
      else if (diasDiferenca < 6) return 5
      else return 6
    },
    conciliacaoTexts () {
      return getValorPercentMessages(this.valorTotal, this.valorConciliadoAutomaticoTotal, this.valorConciliadoManualTotal)
    },
    percGlosaInicial () {
      if (!this.pagamento.valorInformado || !this.pagamento.valorGlosaProducao) return 0
      else return (this.pagamento.valorGlosaProducao / this.pagamento.valorInformado)
    },
    pagamentoStatusLabel () {
      if (this.pagamento.status in pagamentoStatusTradimus && !this.isUsuarioTradimus) {
        return 'Em processamento Tradimus'
      } else {
        return pagamentoStatusLabels[this.pagamento.status]
      }
    },
    pagamentoStatusIcon () {
      if (this.pagamento.status in pagamentoStatusTradimus && !this.isUsuarioTradimus) {
        return 'fa fa-user-clock'
      }
      return this.statusIcons[this.pagamento.status]
    },
    pagamentoActions () {
      const actions = [
        {
          title: this.pagamento.dataQuitacao == null ? 'Quitar pagamento' : 'Desquitar pagamento',
          onClick: this.handleQuitarClick,
          icon: 'fas fa-money-bill-wave',
          disabled: !this.isPagamentoConcluido,
          exclusivoCliente: true
        },
        {
          title: 'Conciliar pagamento',
          onClick: this.handleConciliarClick,
          icon: 'fa-compress-arrows-alt',
        },
        {
          title: 'Integrar pagamento',
          onClick: this.handleIntegrarClick, // TODO: Listar logs de integração
          icon: 'fa-exchange-alt',
          disabled: this.pagamento.statusIntegracaoErp == 0 || !this.isPagamentoConcluido
        },
        {
          title: 'Histórico de pagamento',
          onClick: this.handleHistoricoOpen,
          icon: 'fas fa-history'
        },
        {
          title: 'Ver resumo do pagamento',
          onClick: this.handleResumoClick, // TODO: Proper action implementation
          icon: 'fa-external-link-alt'
        },
        {
          title: 'Resultado',
          onClick: () => this.handleDownloadResultado(),
          icon: 'fa-file-invoice',
          disabled: !this.isPagamentoConcluido
        },
        {
          title: 'DAC - Demonstrativo de Análise de Conta',
          onClick: () => this.handleDownloadDAC(),
          icon: 'fa-file-archive',
          disabled: !this.isPagamentoConcluido
        }
      ]
      return actions.filter(action => !(this.isUsuarioTradimus && action.exclusivoCliente))
    },
    isPagamentoConcluido () {
      return this.pagamento.status === 'concluido'
    },
    ComentariosCount () {
      return this.pagamento.comentariosCount || 0
    },
    percentProducao () {
      const totalProducao =  (this.pagamento.valorPagoProducao + this.pagamento.valorGlosaProducao)
      const conciliadoProducao = (this.pagamento.valorPagoProducaoConciliado + this.pagamento.valorGlosaProducaoConciliado)

      if (totalProducao == 0) return 0

      return conciliadoProducao/totalProducao
    },
    percentRecurso () {
      const totalRecurso = (this.pagamento.valorPagoRecurso + this.pagamento.valorGlosaMantida)
      const conciliadoRecurso = (this.pagamento.valorPagoRecursoConciliado + this.pagamento.valorGlosaMantidaConciliado )

      if (totalRecurso == 0) return 0

      return conciliadoRecurso/totalRecurso
    }
  }
}
</script>

<template>
  <v-container class="py-0 px-1">
    <v-expansion-panel
      class="mb-4 pa-0"
      @click="pagamentoClick(pagamento.id)"
    >
      <v-expansion-panel-header class="py-0 pr-3">
        <v-row class="ma-0">
          <v-col cols="4" style="display: flex">
            <div class="icon-wrapper">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon class="pa-0" small @click="handleComentariosCLick">{{ ComentariosCount > 0 ? 'fas fa-comment' : 'far fa-comment' }}</v-icon>
                  </span>
                </template>
                <span
                  class="px-3 py-1 ma-0"
                  style="
                    border: solid 1px #999;
                    border-radius: 5px;
                    background-color: #fff;"
                >
                  {{ ComentariosCount | pluralize }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="pagamento-status">
                    <v-icon class="pa-0" small>
                      {{ pagamentoStatusIcon }}
                    </v-icon>
                  </span>
                </template>
                <span
                  class="px-3 py-1 ma-0"
                  style="
                    border: solid 1px #999;
                    border-radius: 5px;
                    background-color: #fff;"
                >
                  {{ pagamentoStatusLabel }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="py-0 d-flex">
                    <v-icon class="pa-0" small :color='isQuitado ? "primary" : "disabled"'>
                      fas fa-money-bill-wave
                    </v-icon>
                  </span>
                </template>
                <span
                  class="px-3 py-1 ma-0"
                  style="
                    border: solid 1px #999;
                    border-radius: 5px;
                    background-color: #fff;"
                >
                  {{ isQuitado ? "Quitado" : "Não quitado" }}
                </span>
              </v-tooltip>
              <v-dialog
                v-model="historicoDialogOpen"
                width="auto"
              >
                <v-card class="pa-6">
                  <h2 class="mb-2">Histórico de eventos</h2>
                  <v-data-table
                    v-if="pagamentoEventosPage"
                    item-key="id"
                    :headers="historicoHeaders"
                    :items="pagamentoEventosPage.data"
                    :loading="$asyncComputed.pagamentoEventosPage.updating"
                    loading-text="Carregando..."
                    :options.sync="historicoOptions"
                    :server-items-length="pagamentoEventosPage.totalSize"
                    :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
                    class="text-no-wrap"
                    dense
                    disable-sort
                  >
                    <template v-slot:item.dataEvento="{ item }">
                      {{ item.dataEvento | formatDate }}
                    </template>
                    <template v-slot:item.authorName="{ item }">
                      {{ item.authorName || "-" }}
                    </template>
                  </v-data-table>
                  <v-card-actions>
                    <v-btn color="primary" block @click="handleHistoricoClose">Fechar histórico</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <IntegracaoIcon v-if="pagamento.integracaoSdi && !isUsuarioTradimus" :percConciliado="10" :pagamento="pagamento"/>
            </div>
            <div class="content-wrapper" style="padding-left: 16px">
              SLA
              <b>D+{{ sla }}</b>
            </div>
            <div class="content-wrapper" style="padding-left: 24px">
              <div >DATA DE PGTO -
                <b>{{ pagamento.dataPagamento | formatDate}}</b>
              </div>
              <b>{{ pagamento.operadoraAns.nome }}</b>
              <br/>
              {{ pagamento.prestador.nome }}
            </div>
          </v-col>
          <v-col cols="8" style="display: flex; flex-direction: row; justify-content: space-evenly">
            <v-col cols="3" class="content-wrapper" style="margin:0 16px 0 -24px;">
              <div>
                <b><span>Conciliação</span></b>
                <v-tooltip top class="pa-0">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="gray">
                      ({{ pagamento.percentualConciliadoValor / 100 | formatPercent }})
                    </span>
                  </template>
                  <div
                    class="px-3 py-1 ma-0"
                    style="
                      min-width: 200px;
                      border-radius: 5px;
                      background-color: #fff;"
                  >
                  <PercentBarGroup
                    :progressBars="[progressBarValores, progressBarItens]"
                  />
                  </div>
                </v-tooltip>
              </div>
              <div style="padding-block: 6px">INFORMADO</div>
              <b>R$ {{ pagamento.valorInformado | formatPrice }}</b>
            </v-col>
            <v-col cols="4" class="content-wrapper" style="margin:0 32px 0 -24px">
              <div>
                <b><span>Produção</span></b>
                <span
                  v-if="pagamento.valorPagoProducao || pagamento.valorGlosaProducao"
                  class="gray"
                >
                  ({{ percentProducao | formatPercent }})
                </span>
              </div>
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div style="display: flex; flex-direction: column">
                  <span style="padding-block: 6px">PAGO</span>
                  <b>
                    <span style="color: green">
                      R$ {{ (pagamento.valorPagoProducao ) | formatPrice }}
                    </span>
                  </b>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: -16px;">
                  <span style="padding-block: 6px">GLOSA INICIAL ({{ percGlosaInicial | formatPercent }})</span>
                  <b>
                    <span style="color: red">
                      R$ {{ (pagamento.valorGlosaProducao) | formatPrice }}
                    </span>
                  </b>
                </div>
              </div>
            </v-col>
            <v-col cols="4" class="content-wrapper">
              <div>
                <b><span>Recurso</span></b>
                <span
                  v-if="pagamento.valorPagoRecurso || pagamento.valorGlosaMantida"
                  class="gray"
                >
                  ({{ percentRecurso | formatPercent }})
                </span>
              </div>
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div style="display: flex; flex-direction: column">
                  <span style="padding-block: 6px">PAGO</span>
                  <b>
                    <span style="color: green">
                      R$ {{ pagamento.valorPagoRecurso | formatPrice }}
                    </span>
                  </b>
                </div>
                <div style="display: flex; flex-direction: column">
                  <span style="padding-block: 6px">GLOSA MANTIDA</span>
                  <b>
                    <span style="color: red">
                      R$ {{ pagamento.valorGlosaMantida | formatPrice }}
                    </span>
                  </b>
                </div>
              </div>
            </v-col>
            <v-col cols="1" class="menu-wrapper">
              <v-menu
                offset-x
                offset-y
                close-on-click
                close-on-content-click
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small class="pa-0">
                      fas fa-ellipsis-v
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <span
                    v-for="(action, index) in pagamentoActions"
                    :key="index"
                  >
                    <v-tooltip
                      right
                      :disabled="!Boolean(action.disabled)"
                    >
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <v-list-item
                            @click="action.onClick"
                            :disabled="Boolean(action.disabled)"
                          >
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="primary">{{ action.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ action.title }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </span>
                      </template>
                      <span> Ação disponível somente para pagamentos concluídos. </span>
                    </v-tooltip>
                  </span>
                </v-list>
              </v-menu>
            </v-col>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row class="content-background">
          <v-col cols="6">
            <div>
              <div class="d-flex justify-space-between mb-2">
                <div style="width: 50%;">
                  <p>Data publicação: <span class="font-weight-bold">{{ pagamento.dataPublicacao | formatDate }}</span></p>
                  <p>Responsável publicação: <span class="font-weight-bold">{{ pagamento.responsavelPublicacao?.nome  || '-' }}</span></p>
                </div>
                <div style="width: 50%;">
                  <p>Data conclusão: <span class="font-weight-bold">{{ pagamento.dataConclusao | formatDate }}</span></p>
                  <p>Responsável conclusão: <span class="font-weight-bold">{{ pagamento.responsavelConclusao?.nome || '-' }}</span></p>
                </div>
              </div>
              <div class="d-flex justify-space-between mb-2">
                <span style="width: 50%;">Atualizado: {{ pagamento.dataAlteracao | formatDate }}</span>
                <span style="width: 50%;">Primeira publicação: {{ pagamento.dataPrimeiraPublicacao | formatDate }}</span>
              </div>
            </div>
          </v-col>
          <v-col cols="2"/>
          <v-col cols="2">
            <div class="percent-wrapper">
              <span class="mr-2">
                Conciliação:
              </span>
              <span class="mr-2">
                {{ +pagamento.percentualConciliadoQuantidade/100 | formatPercent }}
              </span>
              <PercentBar
                :total="+pagamento.percentualConciliadoQuantidade"
                :automatica="+pagamento.percentualConciliadoQuantidadeAutomatico"
                :manual="+pagamento.percentualConciliadoQuantidadeManual"
                :textAutomatica="itensConciliacaoTexts.textAutomatica"
                :textManual="itensConciliacaoTexts.textManual"
                :textRestante="itensConciliacaoTexts.textRestante"
              />
            </div>
          </v-col>
          <v-col cols="2">
            <div>
              <v-switch
                v-model="groupedByNotaFiscal"
                label="Agrupar por nota fiscal"
              />
            </div>
          </v-col>
        </v-row>

        <pagamento-lotes-grouped-table
          v-if="groupedByNotaFiscal && groupedPagamentoLotes"
          :groupedPagamentoLotes="groupedPagamentoLotes"
        />

        <div
          v-if="lotesList.length > 0 && !groupedByNotaFiscal"
        >
          <v-data-table
            :headers="lotesHeaders"
            :items="lotesList"
            hide-default-footer
            class="pgtosLotesListTable"
            dense
          >
            <template v-slot:item.numeroLote="{ item }" class="px-1 py-0">
              <b>{{ item.numeroLote }}</b>
            </template>
            <template v-slot:item.numeroProtocolo="{ item }">
              <b>{{ item.numeroProtocolo }}</b>
            </template>
            <template v-slot:item.valorInformado="{ item }">
              <b>R$ {{ item.valorInformado | formatPrice }}</b>
            </template>
            <template v-slot:item.valorConciliado="{ item }">
              <b>R$ {{ (item.valorItensConciliacaoManual + item.valorItensConciliacaoAutomatica) | formatPrice }}</b>
            </template>
            <template v-slot:item.valorLiberado="{ item }">
              <b style="color: green">
                R$ {{ item.valorPago | formatPrice }}
              </b>
              <span v-if="item.valorInformado">
                ({{ item.valorPago/item.valorInformado | formatPercent }})
              </span>
              <span v-else>
                ({{ 0 | formatPercent }})
              </span>
            </template>
            <template v-slot:item.valorGlosado="{ item }">
              <b style="color: red">
                R$ {{ item.valorGlosado | formatPrice }}
              </b>
              <span v-if="item.valorInformado">
                ({{ item.valorGlosado/item.valorInformado | formatPercent }})
              </span>
              <span v-else>
                ({{ 0 | formatPercent }})
              </span>
            </template>
          </v-data-table>
          <v-pagination
            v-if="totalLotesPages > 1"
            v-model="pageLotes"
            :length="totalLotesPages"
            :total-visible="7"
            @input="getLotesPagamento(pageLotes)"
            class="no-box-shadow"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<style scoped>
p {
  margin: 0;
}
button.v-expansion-panel-header {
  background-color: #d1dcea;
  border-radius: 2px;
  padding: 0;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel::after {
  display: none;
}
.v-expansion-panel-content {
  display: flex;
  margin: 0 -24px;
}
.tooltip-box {
  border: solid 1px #999;
  border-radius: 5px;
  background-color: #fff;
  padding: 1 3;
  margin: 0;
}
.theme--light.v-data-table.pgtosLotesListTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child,
.theme--light.v-data-table.pgtosLotesListTable
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.check-header-rec2 {
  position: absolute;
  margin-top: 10px;
  margin-left: -4px;
}
.no-box-shadow {
  box-shadow: 0 0 0 0 !important;
  padding-block: 12px;
}
.content-wrapper {
  padding-block: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  line-height: 1;
}
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
}

@media only screen and (max-width: 992px) {
  .icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
}
@media only screen and (min-width: 992px) {
  .pagamento-status {
    padding: 0 16px;
  }
}
.v-expansion-panel-header .row {
  align-items: center;
}
.content-background {
  background-color: #eff3f8;
  margin: 0;
  align-items: center;
}
.percent-wrapper {
  align-items: center;
}
.menu-wrapper {
  display: flex;
  justify-content: space-around;
  padding-left: 24px;
}
</style>
